module.exports = __webpack_public_path__ + "assets/9b5ba80a9978f3f155c110a8ac0cd671.mp3";